const getters = {
  getListCategory: state => state.listCategory,
  getListCountry: state => state.listCountry,
  getListCity: state => state.listCity,
  getListNeighborhood: state => state.listNeighborhood,
  getListLevelExprerience: state => state.listLevelExprerience,
  getDetailJob: state => state.jobDetail,
  getDetailJobNew: state => state.jobDetailNew
}

export default getters



// WEBPACK FOOTER //
// ./src/store/modules/post-a-job/getters.js